import script from "./period-picker-sidebar-trigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./period-picker-sidebar-trigger.vue?vue&type=script&setup=true&lang=ts"

import "./period-picker-sidebar-trigger.vue?vue&type=style&index=0&id=1bc67c05&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc67c05"]])

export default __exports__